// extracted by mini-css-extract-plugin
export var featuredImageHeight = "40vh";
export var navbarHeight = "50rem";
export var maxFooterHeight = "64rem";
export var blogHeaderIcons = "BlogPost-module--blog-header-icons--1yAJh";
export var blogPostTitle = "BlogPost-module--blog-post-title--Aa7jS";
export var blogFeaturedImage = "BlogPost-module--blog-featured-image--2p2EL";
export var blogPostContent = "BlogPost-module--blog-post-content--3C3cd";